<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 532 283">
    <path fill="#fff" d="M0 282.717v-62.5886h531.441v62.5886z"/>
    <path fill="#fff" d="m103.176 35.2625 54.20331759-31.2943 139.958 242.41436693-54.20331759 31.2943z"/>
    <path fill="#fff" d="m368.95 0 54.20331759 31.2943-134.6 233.1340387L234.35 233.1340387z"/>
</svg>
